import { useEffect, useState } from "react";
import { api, type FinanceStatus } from "../api";

export function financeChanged() { window.dispatchEvent(new Event("finance-changed")); }

export function useFinance() {
  const [status, setStatus] = useState<FinanceStatus | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    const reload = () => api.financeStatus().then(s => { if (alive) { setStatus(s); setError(""); } })
      .catch(e => { if (alive) { setStatus(null); setError(e.message); } });
    void reload();
    window.addEventListener("finance-changed", reload);
    return () => { alive = false; window.removeEventListener("finance-changed", reload); };
  }, []);
  const active = (module: string) => !!status?.modules.some(m => m.module === module && m.ready && m.eligible && m.active);
  return { status, error, active };
}
